module.exports = __webpack_public_path__ + "img/alien-technology.7a6e27ef.png";